/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Email, EmailApplications } from "../../../Constant";
import { useAppDispatch } from "../../../Redux-Toolkit/Hooks";
import { setAllEmails } from "../../../Redux-Toolkit/Reducers/EmailSlice";
import { EmailApi } from "../../../api";
import EmailApplicationContain from "./EmailApplicationContain";
import EmailTabOrg from "./EmailTabOrg";
import { MailSideBar } from "../Common/MailSideBar";
import { toast } from "react-toastify";

const EmailApplicationContainer = () => {
  const [orgactiveTab, setOrgActiveTab] = useState<string | number>(1);
  const dispatch = useAppDispatch();
  const fetchAllEmailAsyn = async () => {
    try {
      await axios.get(EmailApi).then((resp) => {
        dispatch(setAllEmails(resp.data));
      });
    } catch (error) {
      toast.error("error"+ error);
    }
  };

  useEffect(() => {fetchAllEmailAsyn()}, []);
  const callback = useCallback((tab: number) => {setOrgActiveTab(tab)}, []);

  return (
    <>
      <Breadcrumbs pageTitle={EmailApplications} parent={Email} title={EmailApplications} />
      <Container fluid>
        <div className="email-wrap">
          <Row>
            <MailSideBar />
            <Col xl="9" className="box-col-8">
              <div className="email-right-aside">
                <Card className="email-body">
                  <Row>
                    <EmailApplicationContain callback={callback} />
                    <EmailTabOrg orgactiveTab={orgactiveTab} />
                  </Row>
                </Card>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default EmailApplicationContainer;
